"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var loginState_1 = require("../../../types/loginState");
var Button_styles_1 = __importDefault(require("../../atoms/Button/Button.styles"));
var InputCheckbox_1 = __importDefault(require("../../atoms/InputCheckbox/InputCheckbox"));
var API_1 = require("../../../middleware/API");
var InputDayRange_1 = __importStar(require("../../atoms/InputDayRange/InputDayRange"));
var StyledFormPage_styles_1 = __importDefault(require("../../styled/StyledFormPage.styles"));
var transformWeekDaysObjectToArray_1 = __importDefault(require("../../../middleware/transformWeekDaysObjectToArray"));
var formTypes_1 = require("../../../types/formTypes");
var AgendaOverview_1 = require("../AgendaOverview/AgendaOverview");
var transformAvailableRanges_1 = __importDefault(require("../../../middleware/transformAvailableRanges"));
var transformDateRangeToAPI_1 = __importDefault(require("../../../middleware/transformDateRangeToAPI"));
var filterEmptyDateRange_1 = __importDefault(require("../../../helpers/filterEmptyDateRange"));
var Loading_1 = __importDefault(require("../../atoms/Loading/Loading"));
var useHideSidebar_1 = __importDefault(require("../../../hooks/useHideSidebar"));
var ClinicAvailability = function (_a) {
    var loggedIn = _a.loggedIn;
    var _b = react_1.useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = react_1.useState(''), clinicName = _c[0], setClinicName = _c[1];
    var _d = react_1.useState(), notAvailableDays = _d[0], setNotAvailableDays = _d[1];
    var _e = react_1.useState(), notAvailableRanges = _e[0], setNotAvailableRanges = _e[1];
    var _f = react_1.useState([InputDayRange_1.emptyRange]), availableRangesClinic = _f[0], setAvailableRangesClinic = _f[1];
    var _g = react_1.useState(false), firstLogin = _g[0], setFirstLogin = _g[1];
    var _h = react_1.useState(false), error = _h[0], setError = _h[1];
    var _j = react_1.useState(false), showForm = _j[0], setShowForm = _j[1];
    var id = react_router_dom_1.useParams().id;
    useHideSidebar_1.default();
    react_1.useEffect(function () {
        var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, item;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API_1.getAvailabilityData()];
                    case 1:
                        data = _a.sent();
                        if (!(data instanceof Error)) {
                            console.log('data', data);
                            if (data.weekdays) {
                                setNotAvailableDays(transformWeekDaysObjectToArray_1.default(data.weekdays));
                            }
                            if (data.unavailable_periods) {
                                setNotAvailableRanges(data.unavailable_periods);
                            }
                            if (data.clinic_availability) {
                                item = data.clinic_availability.find(function (item) { return item.id.toString() === id; });
                                if (item) {
                                    setClinicName(item.clinic[0].name);
                                    setAvailableRangesClinic(transformAvailableRanges_1.default(data.clinic_availability));
                                }
                            }
                        }
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        getData();
        if (window.location.hash === '#first') {
            setFirstLogin(true);
        }
    }, []);
    var sendData = function () {
        var hasError = false;
        // add new value, create record
        filterEmptyDateRange_1.default(availableRangesClinic)
            .filter(function (item) { return item.state === formTypes_1.NEW; })
            .map(function (item) {
            API_1.postClinicAvailabilityData(transformDateRangeToAPI_1.default(id, item));
        });
        // update value
        availableRangesClinic
            .filter(function (item) { return item.state === formTypes_1.UPDATED; })
            .map(function (item) {
            API_1.putClinicAvailabilityData(transformDateRangeToAPI_1.default(id, item));
        });
        // delete value
        availableRangesClinic
            .filter(function (item) { return item.state === formTypes_1.DELETED; })
            .map(function (item) {
            API_1.deleteClinicAvailabilityData(transformDateRangeToAPI_1.default(id, item));
        });
        setError(hasError);
        if (!hasError) {
            if (!firstLogin) {
                window.location.href = '/confirmed'; // refresh page
            }
            else {
                window.location.href = '/availability#step2'; // refresh page
            }
        }
    };
    var setValues = function (id, values) {
        setAvailableRangesClinic(values);
    };
    if (loggedIn !== loginState_1.LOGGEDIN) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/login" });
    }
    if (isLoading) {
        return react_1.default.createElement(Loading_1.default, null);
    }
    return (react_1.default.createElement(StyledFormPage_styles_1.default, null,
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement(StyledFormPage_styles_1.default, null,
                    react_1.default.createElement("div", { className: "btn-wrapper" },
                        react_1.default.createElement(react_router_dom_1.Link, { to: "/availability-overview" },
                            react_1.default.createElement(Button_styles_1.default, null,
                                react_1.default.createElement("svg", { className: "icon icon-arrow icon-left", "aria-hidden": "true" },
                                    react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#arrow-left" })),
                                react_1.default.createElement("span", null, "Terug")))),
                    react_1.default.createElement("div", { className: "header" },
                        react_1.default.createElement("h1", { className: "title" },
                            "Beschikbaarheid ",
                            clinicName),
                        react_1.default.createElement("p", { className: "description" },
                            "Al je clinics zijn beschikbaar van ",
                            react_1.default.createElement("span", { className: "green" }, "1-7-2023"),
                            " t/m",
                            ' ',
                            react_1.default.createElement("span", { className: "green" }, "31-05-2024"),
                            ".",
                            ' ',
                            notAvailableDays && notAvailableDays.length && (react_1.default.createElement("span", null,
                                "Behalve op ",
                                react_1.default.createElement("span", { className: "green" },
                                    notAvailableDays.join(', '),
                                    " "))),
                            notAvailableRanges && notAvailableRanges.length && react_1.default.createElement("span", null, "en "),
                            notAvailableRanges &&
                                notAvailableRanges.length &&
                                notAvailableRanges.map(function (item) { return (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement("span", { key: item.id, className: "notAvailableRange" },
                                        react_1.default.createElement("span", { className: "green" }, AgendaOverview_1.formatDate(item.start_date)),
                                        " t/m ",
                                        react_1.default.createElement("span", { className: "green" }, AgendaOverview_1.formatDate(item.end_date))))); }))))),
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "toggle" },
                    react_1.default.createElement(InputCheckbox_1.default, { id: 'toggle', label: 'Pas beschikbaarheid aan voor deze clinic', checked: showForm, valueChanged: function () { return setShowForm(!showForm); } })),
                showForm && (react_1.default.createElement("form", null,
                    react_1.default.createElement("div", { className: "group" },
                        react_1.default.createElement(InputDayRange_1.default, { label: 'Datum beschikbaarheid', name: 'datum', value: availableRangesClinic, valueChanged: setValues, id: 'rangesClinicAvailable' })))),
                error && react_1.default.createElement("p", { className: "error" }, "Er ging iets mis met het versturen van het formulier"),
                react_1.default.createElement(Button_styles_1.default, { className: "button secondary", onClick: sendData },
                    react_1.default.createElement("span", null, "Bevestig"),
                    react_1.default.createElement("svg", { className: "icon icon-arrow icon-right", "aria-hidden": "true" },
                        react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#arrow-right" })))))));
};
exports.default = ClinicAvailability;
